export const FILTER_CATEGORY = "feature/Product/FILTER_CATEGORY";
export const FILTER_TAG = "feature/Product/FILTER_TAG";
export const FILTER_SEARCH = "feature/Product/FILTER_SEARCH";
export const SET_PAGES = "feature/Product/SET_PAGES";
export const SET_CURRENT_PAGE = "feature/Product/SET_CURRENT_PAGE";